export const RoleConfig = {
  api: {
    // get
    index: '/dashboard/roles/',
    // post
    create: '/dashboard/roles/',
    // patch
    update: (id = 'uuid') => {
      return `/dashboard/roles/${id}/`
    },
    detail: (id = 'uuid') => {
      return `/dashboard/roles/${id}/`
    },
  },
  events: {
    name: 'role',
    // refresh-index-data
    refresh: `rid-role`,
    // slideover-right
    sorId: 'role',
    sorOpen: 'sor-open-role',
    sorClose: 'sor-close-role',
    sorToggle: 'sor-toggle-role',
    // editing-data
    editingData: 'edit-role-data',
    // viewing-data
    viewingData: 'view-role-data',
  },
}
